module.exports = {
  src: __webpack_public_path__ + "assets/images/gcalendar_icon.076dfd79401d8fd5.svg",
  width: 22,
  height: 22,
  toString: function() { return __webpack_public_path__ + "assets/images/gcalendar_icon.076dfd79401d8fd5.svg"; }
};